/**
 * ÉPRIS Priority Toggle - High Performance Version (Safe Mode)
 * Fixes: "Identifier has already been declared" Error
 */

// 1. FIX: Wir nutzen 'window.', damit der Browser nicht meckert, 
// wenn das Skript ein zweites Mal durch AJAX geladen wird.
window.PriorityConfig = {
  GIFT_ID: 49521187422551,
  PRIORITY_ID: 50166180086103, // Deine Priority ID
  DRAWER_SECTION: 'cart-drawer', // Der Name deiner Section
  TOTAL_SELECTOR: '[data-hulkapps-cart-total]' // Dein Preis-Element
};

// 2. FIX: Intelligenter Start
// Prüft, ob die Seite noch lädt oder ob wir durch einen AJAX-Call (Warenkorb-Update) reinkommen.
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", () => {
     if(window.PriorityToggle) window.PriorityToggle.init();
  });
} else {
  // Seite ist schon fertig geladen (AJAX Fall) -> Sofort starten!
  setTimeout(() => {
     if(window.PriorityToggle) window.PriorityToggle.init();
  }, 50);
}

// 3. FIX: Objekt an window binden statt 'const'
window.PriorityToggle = {
  init() {
    this.bindAll();
    this.setupObserver();
  },

  bindAll() {
    // Zugriff über das globale Objekt oder direkt
    this.bind('gift-toggle', window.PriorityConfig.GIFT_ID);
    this.bind('priority-toggle', window.PriorityConfig.PRIORITY_ID);
  },

  bind(toggleId, variantId) {
    const toggle = document.getElementById(toggleId);
    
    // Schutz: Nicht doppelt binden
    if (!toggle || toggle.dataset.bound === 'true') return;
    toggle.dataset.bound = 'true';

    // Status Check (nur wenn wir nicht sicher sind)
    if (!toggle.dataset.checkedInit) {
      this.checkInitialState(toggle, variantId);
    }

    // Event Listener
    toggle.addEventListener('change', (e) => this.handleObjChange(e, toggle, variantId));
  },

  async checkInitialState(toggle, variantId) {
    try {
      // Wenn wir den Cart schon irgendwo global haben, nutze ihn, sonst fetch
      const cart = await fetch('/cart.js').then(r => r.json());
      toggle.checked = cart.items.some(i => i.variant_id === variantId);
      toggle.dataset.checkedInit = 'true';
    } catch (e) {}
  },

  async handleObjChange(e, toggle, variantId) {
    // 1. UI sofort sperren & Feedback geben
    toggle.disabled = true;
    document.body.style.cursor = 'wait';
    const isAdding = e.target.checked;
    const config = window.PriorityConfig; // Sicherer Zugriff

    try {
      if (isAdding) {
        // --- ADD CASE (Optimiert: Parallel) ---
        const [addRes, cartRes] = await Promise.all([
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: config.DRAWER_SECTION
            })
          }),
          fetch('/cart.js') // Für den absolut sicheren Gesamtpreis
        ]);

        const addData = await addRes.json();
        const cartData = await cartRes.json();
        
        // UI Updates mit den Daten aus dem Response
        this.updateUI(addData.sections[config.DRAWER_SECTION], cartData);

      } else {
        // --- REMOVE CASE (Maximum Speed) ---
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: String(variantId),
            quantity: 0,
            sections: config.DRAWER_SECTION
          })
        });

        const data = await res.json();
        
        // UI Updates direkt mit den Daten aus diesem einen Request
        this.updateUI(data.sections[config.DRAWER_SECTION], data);
      }

    } catch (err) {
      console.error('Toggle Error:', err);
      // Fallback: Wenn was schiefgeht, Toggle zurücksetzen
      toggle.checked = !isAdding;
    } finally {
      toggle.disabled = false;
      document.body.style.cursor = 'default';
    }
  },

  updateUI(html, cartData) {
    const config = window.PriorityConfig;

    // 1. Drawer HTML ersetzen
    if (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('#cart-drawer');
      const currentDrawer = document.querySelector('#cart-drawer');
      
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    }

    // 2. Preis updaten
    const totalElem = document.querySelector(config.TOTAL_SELECTOR);
    if (totalElem && cartData.total_price) {
      totalElem.textContent = (cartData.total_price / 100).toFixed(2).replace('.', ',') + ' €';
    }

    // 3. Shopify Events feuern (für andere Apps)
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
    
    // 4. Progress Bar Update (Jetzt sicher aufgerufen)
    if (typeof window.updateCartProgressBar === 'function') {
      window.updateCartProgressBar(cartData);
    }
  },

  setupObserver() {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;

    // Observer Debounce
    const observer = new MutationObserver((mutations) => {
       const giftToggle = document.getElementById('gift-toggle');
       const prioToggle = document.getElementById('priority-toggle');
       
       if ((giftToggle && giftToggle.dataset.bound !== 'true') || 
           (prioToggle && prioToggle.dataset.bound !== 'true')) {
           
           requestAnimationFrame(() => this.bindAll());
       }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }
};